import React from "react";
import * as Auth from "../../domains/AuthDomain";
import standardizeEmail from "../../common/standardizeEmail";

class DeleteAccount extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      emailValid: false,
      emailError: "",
      successMessage: "",
      success: false,
      authLoading: false,
      confirmCanceledSub: false,
      confirmDelete: false,
    };
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  renderHeader = () => {
    let sectionsClass = "navbar-section";
    if (this.props.route.navBarColor === "trybe-black") {
      sectionsClass = "navbar-section-black";
    }

    return (
      <div className="navbar-section-black">
        <div className="navbar-content">
          <div
            className="logo-container"
            onClick={() => {
              window.location.href = "https://trybe.fit";
            }}
          >
            <img
              className="logo-img"
              src={require("../../images/trybe-logo-white.svg")}
            />
            <div className="logo-text">TRYBE</div>
          </div>
        </div>
      </div>
    );
  };

  onClickDelete = async () => {
    this.setState({ authLoading: true });
    let { email, password } = this.state;
    email = standardizeEmail(email);
    const emailValid = Auth.checkEmailValid(email);

    if (emailValid && password) {
      try {
        const { success, error, error_msg } = await Auth.deleteUser({
          email,
          password,
        })

        if (success) {
          this.setState({
            success: true,
            emailError: false,
            authLoading: false,
          });
        } else if (error && error_msg) {
          this.setState({
            success: false,
            emailError: error_msg,
            authLoading: false,
          });
        }
      } catch (err) {
        const message =
          err && err.error_msg
            ? err.error_msg
            : "There was an error attempting to delete your account. Please contact support@trybe.do";

        this.setState({
          success: false,
          emailError: message,
          authLoading: false,
        });
      }
    } else {
      this.setState({
        success: false,
        emailError:
          "Please double check you entered a valid email and password",
        authLoading: false,
      });
    }
  };

  onClickBack = () => {
    this.props.history.goBack();
  };

  canGoBack = () => {
    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.allowBack
    ) {
      return true;
    } else {
      return false;
    }
  };

  renderBack = () => {
    if (this.canGoBack()) {
      return (
        <button
          onClick={() => {
            this.onClickBack();
          }}
          className="back-button"
        >
          Back
        </button>
      );
    } else {
      return <div className="spacer"></div>;
    }
  };

  render() {
    const promptText = `Enter your account email & password in order to delete your account.`;
    const successText = `Your account was successfully deleted. The process may take a few minutes to fully complete. If you have any questions or forgot to cancel your subscription contact support@trybe.do.`;
    const confirmText =
      "I confirm that I have cancelled all active subscriptions and that I will lose access immediately upon account deletion.";
    const confirmText2 =
      "I would like to permanently delete my account and associated information.";

    return (
      <div className="delete-account-container">
        {this.renderHeader()}
        <div className="main-form">
          {this.props.route.coachName ? (
            <div className="form-header">
              Bodyweight Warrior - Delete Account
            </div>
          ) : (
            <div className="form-header">Delete Account</div>
          )}
          <div className="padding-wrapper">
            {!this.state.success ? (
              <div className="form-description">{promptText}</div>
            ) : (
              <div className="form-description">{successText}</div>
            )}

            {!this.state.success ? (
              <input
                type="text"
                className="email-input"
                placeholder="E-mail"
                id="login-email"
                maxLength="254"
                onChange={(event) => {
                  this.setState({ email: event.target.value });
                }}
                value={this.state.email}
              />
            ) : null}

            {!this.state.success ? (
              <input
                type="password"
                className="password-input"
                placeholder="Password"
                id="login-password"
                maxLength="254"
                onChange={(event) => {
                  this.setState({ password: event.target.value });
                }}
                value={this.state.password}
              />
            ) : null}

            {!this.state.success ? (
              <div className="cancelled-prompt">
                <div
                  className="checkbox-container"
                  onClick={() =>
                    this.setState({
                      confirmCanceledSub: !this.state.confirmCanceledSub,
                    })
                  }
                >
                  {this.state.confirmCanceledSub ? (
                    <div className="checkmark" />
                  ) : null}
                </div>
                <div className="prompt-text">{confirmText}</div>
              </div>
            ) : null}

            {!this.state.success ? (
              <div className="cancelled-prompt">
                <div
                  className="checkbox-container"
                  onClick={() =>
                    this.setState({ confirmDelete: !this.state.confirmDelete })
                  }
                >
                  {this.state.confirmDelete ? (
                    <div className="checkmark" />
                  ) : null}
                </div>
                <div className="prompt-text">{confirmText2}</div>
              </div>
            ) : null}
            <div className="login-messages">
              <div className="error-text">
                {this.state.emailError ? this.state.emailError : null}
              </div>
            </div>
            {!this.state.success ? (
              <button
                type="button"
                className="finish-button"
                disabled={
                  !(this.state.email && this.state.password) ||
                  !this.state.confirmDelete ||
                  !this.state.confirmCanceledSub
                }
                onClick={() => {
                  this.onClickDelete();
                }}
              >
                {this.state.authLoading ? (
                  <div className="loader" />
                ) : (
                  "DELETE ACCOUNT"
                )}
              </button>
            ) : (
              this.renderBack()
            )}
          </div>
        </div>
        <div className="contact-us">
          Need further support? Contact us at{" "}
          <a className="link" href="mailto:support@trybe.do">
            support@trybe.do
          </a>
        </div>
        <div className="contact-us">
          Forgot your password? Click{" "}
          <a className="link" href="https://trybe.do/forgotpassword">
            here
          </a>
        </div>
      </div>
    );
  }
}

export default DeleteAccount;



// WEBPACK FOOTER //
// ./src/components/pages/DeleteAccount.js